import { render, staticRenderFns } from "./banner-list.vue?vue&type=template&id=592abfe3&scoped=true"
import script from "./banner-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./banner-list.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./banner-list.vue?vue&type=style&index=0&id=592abfe3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592abfe3",
  null
  
)

export default component.exports